//TODO: 7.33.0 -> line 16 -> errors: Record<string, FieldError>
//TODO: v7.0.0-alpha.0 -> formState.touchedFields -> formState.touchedFieldsFields

import React, {useEffect} from 'react'
import {
  FieldErrors,
  FieldValues,
  FormState,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form'
import { Col, Form } from 'react-bootstrap'
import { setCityViaZip } from '../../store/participant/participant'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { RootState } from '../../store'
import { updateRegistration } from '../../store/registrations/registrations'
import { IChild, IParticipant } from '../../store/participant/interfaces'

export interface FormFieldProperties<PersonType> {
  errors: FieldErrors
  formState: FormState<FieldValues>
  person: PersonType
  loadedViaCode: boolean
  register: UseFormRegister<FieldValues>
}

export const ChildNameField = (props: {
  formFieldProperties: FormFieldProperties<IChild>
  child: number
}) => {
  const { errors, formState, person, loadedViaCode, register } = props.formFieldProperties
  return (
    <Col>
      <Form.Group controlId={`child-name_${props.child}`}>
        <Form.Label>Name*</Form.Label>
        <Form.Control
          {...register('name')}
          type='text'
          isValid={formState.touchedFields.name && !errors.name}
          isInvalid={!!errors.name}
          defaultValue={person.name}
          disabled={loadedViaCode}
          autoComplete='name'
        />
        <Form.Control.Feedback type='invalid'>
          {errors?.name && errors.name.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const FirstNameField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  return (
    <Col>
      <Form.Group controlId='first_name'>
        <Form.Label>Vorname*</Form.Label>
        <Form.Control
          {...register('first_name')}
          type='text'
          isValid={formState.touchedFields.first_name && !errors.first_name}
          isInvalid={!!errors.first_name}
          defaultValue={person.first_name}
          disabled={loadedViaCode}
          autoComplete='given-name'
        />
        <Form.Control.Feedback type='invalid'>
          {errors.first_name && errors.first_name.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const LastNameField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  return (
    <Col>
      <Form.Group controlId='last_name'>
        <Form.Label>Nachname*</Form.Label>
        <Form.Control
          {...register('last_name')}
          type='text'
          isValid={formState.touchedFields.last_name && !errors.last_name}
          isInvalid={!!errors.last_name}
          defaultValue={person.last_name}
          disabled={loadedViaCode}
          autoComplete='family-name'
        />
        <Form.Control.Feedback type='invalid'>
          {errors.last_name && errors.last_name.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const GenderField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  let gender: string = person.gender
  return (
    <Col>
      <Form.Group controlId='gender'>
        <Form.Label>Geschlecht*</Form.Label>
        <Form.Control
          {...register('gender')}
          as='select'
          name='gender'
          defaultValue={gender}
          disabled={loadedViaCode}
          isValid={formState.touchedFields.gender && !errors.gender}
          isInvalid={!!errors.gender}
          autoComplete='sex'
        >
          <option value={''} />
          <option value='m'>Männlich</option>
          <option value='w'>Weiblich</option>
          <option value='d'>Divers</option>
        </Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.gender && errors.gender.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const DateOfBirthField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant | IChild>
  child?: number
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  return (
    <Col>
      <Form.Group
        controlId={
          props.child ? `date_of_birth_child_${props.child}` : 'date_of_birth'
        }
      >
        <Form.Label>Geburtstag*</Form.Label>
        <Form.Control
          {...register('date_of_birth')}
          type='text'
          defaultValue={person.date_of_birth}
          isValid={formState.touchedFields.date_of_birth && !errors.date_of_birth}
          isInvalid={!!errors.date_of_birth}
          disabled={loadedViaCode}
          autoComplete='bday'
          placeholder='24.12.2000'
        />
        <Form.Control.Feedback type='invalid'>
          {errors.date_of_birth && errors.date_of_birth.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const DisabledField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>,
  setShowDisabled: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const { setShowDisabled, formFieldProperties } = props
  const { person, loadedViaCode, register } = formFieldProperties

  return (
    <Col>
      <Form.Group className={"input-group"}>
        <Form.Check
          {...register('disabled')}
          type='checkbox'
          disabled={loadedViaCode}
          defaultChecked={person.disabled}
          onChange={() => setShowDisabled((previous) => !previous)}
        />
        <Form.Label>Behinderung/Beeinträchtigung</Form.Label>
    </Form.Group>
    </Col>
  )
}

export const HandicapField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const { person, loadedViaCode, register } = props.formFieldProperties
  return (
    <Col>
      <Form.Group controlId='handicap'>
        <Form.Label>Details zur Behinderung/Beeinträchtigung</Form.Label>
        <Form.Control
          {...register('handicap')}
          disabled={loadedViaCode}
          defaultValue={person.handicap}
          maxLength={300}
        />
      </Form.Group>
    </Col>
  )
}

export const LegalGuardianField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const { person, loadedViaCode, register } = props.formFieldProperties
  return (
    <Col>
      <Form.Group controlId='legal_guardian'>
        <Form.Label>Erziehungsberechtigter</Form.Label>
        <Form.Control
          {...register('legal_guardian')}
          type='text'
          defaultValue={person.legal_guardian}
          disabled={loadedViaCode}
        />
      </Form.Group>
    </Col>
  )
}

export const SecondLegalGuardianField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const { person, loadedViaCode, register } = props.formFieldProperties
  return (
    <Col>
      <Form.Group controlId='second_legal_guardian'>
        <Form.Label>Zweiter Erziehungsberechtigter</Form.Label>
        <Form.Control
          {...register('second_legal_guardian')}
          type='text'
          defaultValue={person.second_legal_guardian}
          disabled={loadedViaCode}
        />
      </Form.Group>
    </Col>
  )
}

export const SchoolField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  const { data: institution } = useAppSelector(
    (state: RootState) => state.institution,
  )
  if (
    'participant-stage' in institution.custom_configuration &&
    'behavior' in institution.custom_configuration['participant-stage'] &&
    institution.custom_configuration['participant-stage']['behavior'] ===
    'custom-school-select'
  ) {
    const receivers =
      institution.custom_configuration['participant-stage']['data']['receivers']
    return (
      <Col>
        <Form.Group controlId='school'>
          <Form.Label>Entsendende Stelle*</Form.Label>
          <Form.Control
            {...register('sending_post')}
            as='select'
            type=''
            defaultValue={person.sending_post}
            disabled={loadedViaCode}
            isValid={formState.touchedFields.sending_post && !errors.sending_post}
            isInvalid={!!errors.sending_post}
          >
            <option value={''}>--------</option>
            {receivers.map(
              (
                value: { name: string; email: string; address: string },
                index: number,
              ) => (
                <option key={index} value={value.name}>
                  {value.name}
                </option>
              ),
            )}
          </Form.Control>
          <Form.Control.Feedback type='invalid'>
            {errors.sending_post && errors.sending_post.message?.toString()}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>
    )
  } else {
    return (
      <Col>
        <Form.Group controlId='school'>
          <Form.Label>Schule</Form.Label>
          <Form.Control
            {...register('school')}
            name='school'
            type='text'
            defaultValue={person.school}
            disabled={loadedViaCode}
          />
        </Form.Group>
      </Col>
    )
  }
}

export const StreetField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  return (
    <Col>
      <Form.Group controlId='street'>
        <Form.Label>Straße + Hausnummer*</Form.Label>
        <Form.Control
          {...register('street')}
          type='text'
          isValid={formState.touchedFields.street && !errors.street}
          isInvalid={!!errors.street}
          defaultValue={person.street}
          disabled={loadedViaCode}
          autoComplete='street-address'
        />
        <Form.Control.Feedback type='invalid'>
          {errors.street && errors.street.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const ZipField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
  getValues: UseFormGetValues<FieldValues>
  setValue: UseFormSetValue<FieldValues>
  colSize?: { xs?: number; sm?: number; md?: number; lg?: number }
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  const { getValues, setValue } = props
  const { data: institution } = useAppSelector(
    (state: RootState) => state.institution,
  )
  const { data: {zip_code} } = useAppSelector(
    (state: RootState) => state.participant,
  )
  const { list: registrations } = useAppSelector(
    (state: RootState) => state.registrations,
  )
  const setCategoriesByZipcode =
    'participant-stage' in institution.custom_configuration &&
    'behavior' in institution.custom_configuration['participant-stage'] &&
    institution.custom_configuration['participant-stage']['behavior'] ===
    'validate-zipcode-with-categories'

  const { data: program } = useAppSelector((state: RootState) => state.program)

  useEffect(() => {
    if (institution.zip_autocomplete !== 'OFF' && zip_code !== "") {
      dispatch(
        setCityViaZip(zip_code, (name: string) => {
          if (name) {
            setValue('city', name)
          }
        }),
      )
    }
  }, [zip_code])

  const dispatch = useAppDispatch()
  return (
    <Col {...(props.colSize ?? {})}>
      <Form.Group controlId='zip_code'>
        <Form.Label>PLZ*</Form.Label>
        <Form.Control
          {...register('zip_code', {
            onChange: () => {
              let zipCode = getValues()['zip_code']
              if (institution.zip_autocomplete !== 'OFF') {
                dispatch(
                  setCityViaZip(zipCode, (name: string) => {
                    if (name) {
                      setValue('city', name)
                    }
                  }),
                )
              }
              if (setCategoriesByZipcode) {
                const mapping = institution.custom_configuration['participant-stage']['data']['mapping']
                const requiredCategory = zipCode in mapping ? mapping[zipCode] : mapping['*']
                for (const reg of registrations) {
                  if (reg.event.price_categories.length > 0) {
                    const category = reg.event.price_categories.find(
                      price_cat => price_cat.name === requiredCategory,
                    )
                    if (
                      category &&
                      (category.has_free_places ||
                        !category.is_waiting_list_full)
                    ) {
                      dispatch(
                        updateRegistration({
                          eventId: reg.event.event_id,
                          priceCategory: category.name,
                        }),
                      )
                    }
                  }
                }
              }
            },
          })
          }
          as={program.restrict_zip_codes ? 'select' : 'input'}
          type='tel'
          isValid={formState.touchedFields.zip_code && !errors.zip_code}
          isInvalid={!!errors.zip_code}
          defaultValue={person.zip_code}
          disabled={loadedViaCode}
          autoComplete='postal-code'
        >
          {program.restrict_zip_codes ? [<option key={'zipcode-empty'} />,
            ...program.restricted_zip_codes.map((code: string) => (
              <option key={`zipcode-${program.restricted_zip_codes.findIndex(c => c === code)}`} value={code}>
                {code}
              </option>
            ))] : null}
        </Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.zip_code && errors.zip_code.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const CityField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
  colSize?: { xs?: number; sm?: number; md?: number; lg?: number }
}) => {
  const { person, errors, loadedViaCode, register } = props.formFieldProperties
  const { data: institution } = useAppSelector(
    (state: RootState) => state.institution,
  )
  if (
    institution.zip_autocomplete === 'ON_NOT_EDITABLE'
  ) {
    delete errors['city']
  }
  return (
    <Col {...(props.colSize ?? {})}>
      <Form.Group controlId='city'>
        <Form.Label>Ort*</Form.Label>
        <Form.Control
          {...register('city')}
          type='text'
          isValid={!errors.city}
          isInvalid={!!errors.city}
          autoComplete='address-level2'
          disabled={
            institution.zip_autocomplete === 'ON_NOT_EDITABLE' || loadedViaCode
          }
          defaultValue={person.city}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.city && errors.city.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const DistrictField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
  colSize?: { xs?: number; sm?: number; md?: number; lg?: number }
}) => {
  const { person, loadedViaCode, register } = props.formFieldProperties
  return (
    <Col {...(props.colSize ?? {})}>
      <Form.Group controlId='district'>
        <Form.Label>Ortsteil</Form.Label>
        <Form.Control
          {...register('district')}
          name='district'
          type='text'
          defaultValue={person.district}
          disabled={loadedViaCode}
          autoComplete='address-level3'
        />
      </Form.Group>
    </Col>
  )
}

export const PhoneField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  return (
    <Col>
      <Form.Group controlId='phone'>
        <Form.Label>Telefon*</Form.Label>
        <Form.Control
          {...register('phone')}
          name='phone'
          type='tel'
          isValid={formState.touchedFields.phone && !errors.phone}
          isInvalid={!!errors.phone}
          defaultValue={person.phone}
          disabled={loadedViaCode}
          autoComplete='tel'
        />
        <Form.Control.Feedback type='invalid'>
          {errors.phone && errors.phone.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const EmailField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  return (
    <Col md={12}>
      <Form.Group controlId='email'>
        <Form.Label>E-Mail-Adresse*</Form.Label>
        <Form.Control
          {...register('email')}
          type='email'
          isValid={formState.touchedFields.email && !errors.email}
          isInvalid={!!errors.email}
          defaultValue={person.email}
          disabled={loadedViaCode}
          autoComplete='email'
        />
        <Form.Control.Feedback type='invalid'>
          {errors.email && errors.email.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const EmailRepeatField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
}) => {
  const {
    errors,
    formState,
    person,
    loadedViaCode,
    register,
  } = props.formFieldProperties
  return (
    <Col>
      <Form.Group controlId='email_repeat'>
        <Form.Label>E-Mail-Adresse wiederholen*</Form.Label>
        <Form.Control
          {...register('email_repeat')}
          type='email'
          isValid={formState.touchedFields.email_repeat && !errors.email_repeat}
          isInvalid={!!errors.email_repeat}
          defaultValue={person.email}
          disabled={loadedViaCode}
          autoComplete='email'
        />
        <Form.Control.Feedback type='invalid'>
          {errors.email_repeat && errors.email_repeat.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export const CodeField = (props: {
  formFieldProperties: FormFieldProperties<IParticipant>
  required: boolean
}) => {
  const { person, loadedViaCode, register, formState, errors} = props.formFieldProperties
  const { required } = props
  return (
    <Col>
      <Form.Group controlId='access_key'>
        <Form.Label>Zugangscode{required ? '*' : ''}</Form.Label>
        <Form.Control
          {...register('access_key')}
          isValid={formState.touchedFields.access_key && !errors.access_key}
          isInvalid={!!errors.access_key}
          type='text'
          required={required}
          defaultValue={person.access_key}
          disabled={loadedViaCode}
          placeholder='xxx-xxx-xxx-xxx'
        />
        <Form.Control.Feedback type='invalid'>
          {errors.access_key && errors.access_key.message?.toString()}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}
